"use strict";

var _hls = _interopRequireDefault(require("hls.js"));

var _HlsLoader = _interopRequireDefault(require("./loader/HlsLoader"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function createHlsStream(fragments, startPosition, streamLevel, sourceUrl, videoRef) {
  var hls = new _hls["default"]({
    loader: _HlsLoader["default"],
    fragments: fragments,
    startPosition: startPosition,
    startLevel: streamLevel,
    capLevelToPlayerSize: true,
    enableWorker: true
  });
  hls.loadSource(sourceUrl);
  hls.attachMedia(videoRef);
  return hls;
}

module.exports = createHlsStream;